import React, { useState } from "react";
import { styled } from "@mui/material/styles";
import { CircularProgress } from "@mui/material";
import toast from "react-hot-toast";

import upload from "../../../styles/svg/upload.svg";
import eye from "../../../styles/svg/eye-view.svg";
import { useCustomSearchParams } from "../../../hooks/useCustomSearchParams";
import { fireReportDelete, noticeReportUpload } from "../../../sevices/fireNoticeApi";
import LongFormDialog from "../../../components/Dialog/LongFormDialog";
import ReportActions from "../../LeadCompliance/components/Table/ReportActions";
import ViewFile from "../../../components/ViewFile";

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

function ReportFireNotice({ id, attachment, refetchUnits, status }) {
  const [anchorEl, setAnchorEl] = useState(false);
  const [refetch, setRefetch] = useCustomSearchParams("refetch");
  const [loading, setLoading] = useState(false);

  const handleClose = () => {
    setAnchorEl(false);
  };
  const handleClick = () => {
    setAnchorEl(true);
  };

  const callback = (res) => {
    toast.success(res.data.message);
    setRefetch("refetch", refetch ? refetch + 1 : 1);
    refetchUnits?.();
  };

  const uploadFile = (e) => {
    setLoading(true);
    const { files } = e.target;
    console.log(files);
    if (files.length) {
      noticeReportUpload({
        fire_notice_id: id,
        report: files[0],
      })
        .then((res) => {
          callback(res);
        })
        .catch((err) => {
          console.log(err);
          toast.error(err.response?.data?.message);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };
  return (
    <>
      {anchorEl && (
        <LongFormDialog
          open={anchorEl}
          handleClose={handleClose}
          title={"Survey Response"}
          btnTitle={"Confirm"}
          IsChildren={
            <ReportActions
              url={"/fire-notice/report/" + attachment}
              name={attachment}
              id={id}
              handleClose={handleClose}
              callback={callback}
              api={fireReportDelete}
            />
          }
        >
          <ViewFile url={"/fire-notice/report/" + attachment} />
        </LongFormDialog>
      )}

      {attachment ? (
        <img src={eye} className="ml-1 cursor-pointer" onClick={handleClick} />
      ) : (
        status == "notice_needed" && (
          <label
            htmlFor={`upload-file-${id}`}
            className="ml-1 cursor-pointer"
            key={`compliance-upload-form-` + id}
          >
            {loading ? (
              <CircularProgress size={18} color="inherit" />
            ) : (
              <img src={upload} />
            )}
            <VisuallyHiddenInput
              type="file"
              onChange={uploadFile}
              id={`upload-file-${id}`}
            />
          </label>
        )
      )}
    </>
  );
}

export default ReportFireNotice;
